module.exports = __webpack_public_path__ + "img/paypal-logo-2@2x.6372c241.png";